<template>

    <div class="galaxy::common-canvas-editor-canvas-document-editors-input-WebsitePageInput">

        <div class="tw-py-3 tw-px-4">

            <div class="tw-mb-1 tw-text-gray-600 label">{{ label }}</div>
            <small class="tw-mb-1 tw-text-gray-600 tw-text-sm" v-if="instruction">{{ instruction }}</small>

            <treeselect
                    :value="internalValue"
                    :options="treeOptions"
                    noChildrenText="Geen pagina's"
                    @input="onInput($event)">

                <template slot="option-label" slot-scope="{ node }">

                    <div
                            v-if="node.raw.type == 'menu'"
                            class="tw-text-sm"
                            :class="{
                                'tw-font-bold': selectedParents.indexOf('websiteMenu-' + node.raw.websiteMenu.id) !== -1,
                                'tw-py-1': true,
                            }">{{ node.raw.name }} menu</div>

                    <div
                            v-else
                            :class="{
                                'tw-bg-none': true,
                                'tw-text-sm': true,
                                'tw-text-blue-400': node.raw.websiteMenuPage.website_page.id == value,
                                'tw-font-bold': node.raw.websiteMenuPage.website_page.id == value || selectedParents.indexOf('websitePage-' + node.raw.websiteMenuPage.website_page.id) !== -1,
                            }">{{ node.raw.title }}</div>

                </template>

                <div slot="value-label" slot-scope="{ node }">{{ node.raw.title }}</div>

            </treeselect>

        </div>

    </div>

</template>

<script>

    import axios from '@galaxy/js/common/AxiosBuilder';
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'

    export default {

        components: {
            Treeselect,
        },

        props: {
            label: {
                type: String,
                default: 'Welke pagina?',
            },
            instruction: String,
            value: Number,
        },

        data()
        {
            return {
                internalValue: null,
                websitePages: null,
                websitePageId2internalId: {},
                selectedParents: [],
            };
        },

        mounted()
        {
            this.loadData();
        },

        methods: {

            async loadData()
            {
                // Load artists.
                this.websitePages = (await axios.get('/admin/canvas-editor/inputs/website-page/data')).data;
            },

            onInput(value)
            {
                // Extract website page id?
                if(value)
                {
                    // Clear due to no menu is selected?
                    if(!value.includes('-'))
                        value = undefined;

                    // Get id from website page item?
                    else
                        value = parseInt(value.split('_websitePage-').pop());
                }
                // Clear value due to none selected?
                else if(value === 0)
                    value = undefined;

                // Update value?
                if(this.value !== value)
                    this.$emit('update:value', value);
            },

            mapItem(websiteMenu, websiteMenuPages, parentIds = [])
            {
                // Abort due to no items? Otherwise Treeselect will show empty subtree.
                if(!websiteMenuPages.length)
                    return undefined;

                // Map items.
                return _.map(websiteMenuPages, websiteMenuPage => {

                    // Map in internal id - to support non-unique items.
                    let internalId = 'menu-' + websiteMenu.id + '_websitePage-' + websiteMenuPage.website_page.id;

                    this.websitePageId2internalId[websiteMenuPage.website_page.id] = internalId;

                    // Add as selected parent?
                    if(this.value == websiteMenuPage.website_page.id)
                        this.selectedParents.push(...parentIds);

                    // Map
                    return {
                        id: internalId,
                        websiteMenuPage,
                        type: 'websitePage',
                        // TODO Medium: Do we want to support multi language here?
                        title: (websiteMenuPage.website_page.title_menu?.nl || websiteMenuPage.website_page.title_page?.nl),
                        children: this.mapItem(
                            websiteMenu,
                            websiteMenuPage.children,
                            [].concat(parentIds, ['websitePage-' + websiteMenuPage.website_page.id])
                        ),
                    };
                });
            },

        },

        computed: {

            treeOptions()
            {
                // Abort due to empty?
                if(this.websitePages === null)
                    return [];

                //
                this.selectedParents = [];
                this.websitePageId2internalId = {};

                // Map website pages.
                let result = _.map(this.websitePages, websiteMenu => {
                    return {
                        id: 'menu_' + websiteMenu.id,
                        websiteMenu,
                        type: 'menu',
                        name: websiteMenu.name,
                        children: this.mapItem(websiteMenu, websiteMenu.website_menu_pages, ['websiteMenu-' + websiteMenu.id]),
                    };
                });

                // Set internal value by internal ids.
                this.internalValue = this.websitePageId2internalId[this.value] || 0;

                //
                return result;
            },

        },

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-editor-canvas-document-editors-input-WebsitePageInput {

        ::v-deep {
            .vue-treeselect__option--selected { background: white !important; }
        }

    }

</style>
